import { makeStyles } from '@material-ui/core'
import { Theme } from 'styling/theme'

export const useStyles = makeStyles((theme: Theme) => ({
    footer: {
        padding: '44px 78px',
        '@media (max-width: 768px)': {
            padding: '48px 20px',
        },
        backgroundColor: '#10141c',
    },
    container: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        '@media (max-width: 768px)': {
            alignItems: 'stretch',
            flexDirection: 'column',
        },
    },
    logo: {
        height: 24,
    },
    title: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    contact: {
        display: 'flex',
        justifyContent: 'space-evenly',
        '@media (min-width: 1024px)': {
            flex: 0.6,
            justifyContent: 'space-evenly',
        },
    },
    content: {
        display: 'flex',
        flex: 1,
        justifyContent: 'space-evenly',
        '@media (max-width: 768px)': {
            flexDirection: 'column',
        },
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        '@media (max-width: 768px)': {
            marginTop: 48,
        },
    },
    social: {
        '@media (max-width: 768px)': {
            alignItems: 'center',
        },
    },
    links: {
        '& > a': {
            fontSize: 14,
            opacity: 0.8,
            alignItems: 'center',
            fontWeight: 600,
            marginRight: 20,
            fontFamily: theme.typographyPresets.fonts.monserrat.regular,
            color: theme.colors.light.offWhite1,
            '&:last-child': {
                marginRight: 0,
            },
            '@media (max-width: 1024px)': {
                marginRight: 10,
                fontSize: 10,
            },
        },
    },
    icon: {
        marginRight: 6,
    },
    text: {
        color: theme.colors.white,
        opacity: 0.6,
        fontSize: 14,
        margin: 0,
        '@media (max-width: 1024px)': {
            fontSize: 10,
        },
    },
}))
